module.exports = ['$scope', '$location', 'ngMeta', function ($scope, $location) {
  'use strict';
  $scope.previewMode = $location.search().preview;
}];


// WEBPACK FOOTER //
// ./web/js/app/headController.js